
export function handleResult<T>(result: { success: boolean; data?: T[]; error?: { message: string } }, operation: string): T[] {
  if (!result.success) {
    console.error(`[contentService] ${operation} failed:`, result.error?.message)
    throw new Error(result.error?.message || `${operation} başarısız oldu`)
  }
  return result.data || []
}